export enum IUploadCategory {
  FILM_FESTIVAL = "FILM_FESTIVAL",
  GENERAL = "GENERAL",
}

export interface IMedia {
    id: string;
    mediaId: string;
    title: string;
    description: string;
    year: string;
    duration: string;
    audience: string;
    directors: string;
    producers: string;
    genre: string;
    publishedDate: string;
    thumbnail: string;
    video: string;
    viewerRating: number;
    planDetails: Array<IMemberPlan>;
    category: IUploadCategory;
}

export interface IMediaRating {
  mediaId: string;
  rating: number;
  ratingId?: string;
  userId?: string;
  clientId?: string;
  timestamp?: string;
}

export interface IEventCardProps {
    id: string;
    title: string;
    date: string;
    isPrivate: boolean;
    planDetails: Array<IMemberPlan>;
    video: string;
}

export interface IMemberPlan {
    id: string;
    name: string;
    description: string;
    amount: number;
    isRecurring?: boolean;
    isEnabled: boolean;
    isPublic: boolean;
    expiration?: string;
    frequency?: string;
    expiryDate?: string;
}
